import React from 'react';
import PropTypes from 'prop-types';
import { UncontrolledTooltip } from 'reactstrap';

const CollectionDescriptionIcon = ({ collection, delay }) => {
  if (!collection.description) return null;

  return (
    <>
      <span className="collection-description-icon" id={`CollectionDescriptionIcon-${collection.uuid}`}>
        <i className="fa-light fa-circle-info" />
      </span>
      <UncontrolledTooltip
        target={`CollectionDescriptionIcon-${collection.uuid}`}
        className="collection-description-tooltip"
        fade={false}
        placement="bottom"
        {...(delay ? { delay: { show: 210, hide: 210 } } : {})}
      >
        {collection.description}
      </UncontrolledTooltip>
    </>
  );
};

CollectionDescriptionIcon.propTypes = {
  delay: PropTypes.bool,
  collection: PropTypes.object.isRequired,
};

CollectionDescriptionIcon.defaultProps = {
  delay: false,
};

export default CollectionDescriptionIcon;
